const dragonsCommonNote = require('./dragons_common')

module.exports = [
  {
    text: `Мне нравятся оживленные дискуссии… только не с белым драконом. Они все совершенно невыносимы и невежественны. Должно быть, в их арктических широтах воздух другой`,
    author: `Физбан`,
  },
  ...dragonsCommonNote,
]
